// Política de frescura del panel; no interviene en permisos del servidor.
export const isAdminSession = () => !!localStorage.getItem('accessToken') && localStorage.getItem('isAdmin') === 'true';

let sequence = 0;
export const freshRequestKey = () => `${Date.now().toString(36)}-${++sequence}`;

const imageVersions = new WeakMap();

// Solo para renderizar: nunca guardar esta URL en el formulario ni en la API.
// Una respuesta nueva tiene objetos nuevos; los rerenders del mismo objeto
// reutilizan la versión para no descargar la imagen en cada interacción.
export const freshAdminImage = (url, owner) => {
  if (!isAdminSession() || typeof url !== 'string' || !/^https?:\/\//i.test(url) || !owner) return url;
  // Los archivos nuevos llevan UUID: cada reemplazo tiene una URL nueva.
  if (/\/products\/[a-f0-9]{32}\.(?:jpg|png|webp|gif|avif)(?:[?#]|$)/i.test(url)) return url;
  if (!imageVersions.has(owner)) imageVersions.set(owner, freshRequestKey());
  const [path, fragment] = url.split('#', 2);
  const version = owner.updated_at || imageVersions.get(owner);
  return `${path}${path.includes('?') ? '&' : '?'}_admin_image=${encodeURIComponent(version)}${fragment ? `#${fragment}` : ''}`;
};
